import React, { PureComponent, Children, cloneElement, isValidElement } from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('InputGroup');

class InputGroup extends PureComponent {
    static propTypes = {
        value: PropTypes.any,
        className: PropTypes.string,
        children: PropTypes.node,
        onChange: PropTypes.func.isRequired,
        onFocus: PropTypes.func.isRequired,
        onBlur: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);
        const { value = {}, children } = this.props;
        const values = Children.toArray(children).reduce((values, child) => {
            if (isValidElement(child)) {
                const { name } = child.props;
                return { ...values, [name]: value[name] };
            }
            return values;
        }, {});
        this.state = values;
        this.inputRefs = {};
    }

    handleChange = (event) => {
        const { onChange } = this.props;
        const { name, value } = event.target;
        this.setState({ [name]: value }, () => onChange(this.state));
    };

    handleFocus = (event) => {
        const { onFocus } = this.props;
        /* istanbul ignore else */
        if (Object.values(this.inputRefs).indexOf(event.relatedTarget) === -1) {
            onFocus(event);
        }
    };

    handleBlur = (event) => {
        const { onBlur } = this.props;
        /* istanbul ignore else */
        if (Object.values(this.inputRefs).indexOf(event.relatedTarget) === -1) {
            onBlur(this.state);
        }
    };

    render() {
        const { id, value = {}, className, children, name, onChange, onFocus, onBlur, ...rest } = this.props; // eslint-disable-line no-unused-vars

        return (
            <div className={bem(null, null, className)}>
                {Children.map(children, (child) =>
                    isValidElement(child)
                        ? cloneElement(child, {
                              value: value[child.props.name] || '', // Empty string required here to create a controlled component
                              onChange: this.handleChange,
                              onFocus: this.handleFocus,
                              onBlur: this.handleBlur,
                              ...(typeof child.type !== 'string' && { inputRef: (node) => (this.inputRefs[child.props.name] = node) }),
                          })
                        : child,
                )}
            </div>
        );
    }
}

export default InputGroup;
